import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { BackChevron } from '../../BackChevron/BackChevron';

type MagazineAuthorHeaderProps = {
  authorName: string;
};

function MagazineAuthorHeader({ authorName }: MagazineAuthorHeaderProps) {
  const t = useTranslations('magazine.author');

  return (
    <div className="flex items-center gap-4" data-testid="magazine-author-header">
      <BackChevron fallbackUrl={ROUTES.MAGAZINE.HOME} />
      <h1 className="heading-5 text-foreground">{t('heading', { name: authorName })}</h1>
    </div>
  );
}

export { MagazineAuthorHeader, type MagazineAuthorHeaderProps };
